"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenExpired = void 0;
const ApiException_1 = require("./ApiException");
class TokenExpired extends ApiException_1.ApiException {
    constructor(message = 'Token as expired.') {
        super(message);
    }
}
exports.TokenExpired = TokenExpired;
